export default __webpack_public_path__ + "3e5f15fddf9051f1e5f9e670923e251b.png";